import { render, staticRenderFns } from "./WattsVarsPfGraph.vue?vue&type=template&id=c4e59980"
import script from "./WattsVarsPfGraph.vue?vue&type=script&lang=js"
export * from "./WattsVarsPfGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports